import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dArray$dNonEmpty$dInternal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
const NonEmptyArray = x => x;
const udecodeNonEmptyArray = dictDecode => Unscramble.decodeNonEmptyArray(dictDecode);
const showNonEmptyArray = dictShow => ({show: v => "(NonEmptyArray " + Data$dShow.showArrayImpl(dictShow.show)(v) + ")"});
const ordNonEmptyArray = dictOrd => Data$dOrd.ordArray(dictOrd);
const newtypeNonEmptyArray = {Coercible0: () => {}};
const functorNonEmptyArray = Data$dFunctor.functorArray;
const foldableNonEmptyArray = Data$dFoldable.foldableArray;
const foldable1NonEmptyArray = Data$dArray$dNonEmpty$dInternal.foldable1NonEmptyArray;
const eqNonEmptyArray = dictEq => ({eq: Data$dEq.eqArrayImpl(dictEq.eq)});
const encodeNonEmptyArray = dictEncode => ({encode: Data$dFunctor.arrayMap(dictEncode.encode)});
const decodeNonEmptyArray = dictDecode => (
  {
    decode: value => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign$dGeneric$dClass.arrayDecode(dictDecode).decode(value))(arr => {
      if (arr.length > 0) { return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(arr); }
      return Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError(Data$dNonEmpty.$NonEmpty(
        Foreign.$ForeignError("ForeignError", "Expected non empty array."),
        Data$dList$dTypes.Nil
      ));
    })
  }
);
export {
  NonEmptyArray,
  decodeNonEmptyArray,
  encodeNonEmptyArray,
  eqNonEmptyArray,
  foldable1NonEmptyArray,
  foldableNonEmptyArray,
  functorNonEmptyArray,
  newtypeNonEmptyArray,
  ordNonEmptyArray,
  showNonEmptyArray,
  udecodeNonEmptyArray
};
